<!-- <div *ngIf="isLoading == true; else hasLoaded">
  <app-spinner></app-spinner>
</div>
<ng-template #hasLoaded> -->
<div class="storage-add" *ngIf="readStorageOption">
  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between center" fxLayoutAlign.lt-md="start stretch" fxLayoutGap.lt-md="10px" class="margin-bottom">
    <h3>{{ "form.storage.addStorage" | translate }}</h3>
    <div fxLayout="row" fxLayoutGap="10px" fxLayout.lt-md="row wrap">
      <button mat-button mat-raised-button mat-dialog-close (click)="cancel()" class="cancel_button">{{ "cancel" | translate }}</button>
      <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="!form.valid"
        data-test="storage-add__Submit">
        {{ 'form.storage.addStorage' | translate }}
      </button>
    </div>
  </div>

    <form [formGroup]="form" class="form">



      <!-- <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" class="cover" *ngIf="locations$ && locations$.length>1">
        <div fxFlex="100" fxFlex.sm="100" fxFlex.xs="100" class="margin-right">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>{{ "locations" | translate }}</mat-label>
            <mat-select class="form-control" formControlName="locationID" (selectionChange)="onLocationChange($event)">
              <mat-option [value]="location.locID" *ngFor="let location of locations$">
                {{location.locName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div> -->

      <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" class="cover">
        <div fxFlex="100" fxFlex.sm="100" fxFlex.xs="100" class="margin-right">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>{{ "form.storage.parentID" | translate }}</mat-label>
            <input type="text"
            aria-label="Number"
            matInput
            [formControl]="searchControl"
            [matAutocomplete]="auto">
            <mat-spinner *ngIf="storagesLoading" diameter="20"></mat-spinner>
            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="onOptionSelection($event.option.id)">
              <mat-option *ngFor="let storage of filteredStorages | async" [value]="storage.path" [id]="storage.storageStructureID" [class.selected]="storage.storageStructureID==parentStorageStructureID">
                <span>{{ storage.path }}</span>
              </mat-option>
            </mat-autocomplete>
            <!-- <mat-icon matSuffix (click)="clearInput()">clear</mat-icon> -->
            <mat-icon matSuffix>keyboard_arrow_down</mat-icon>
          </mat-form-field>
        </div>
      </div>

      <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" class="cover">
        <div fxFlex="100" fxFlex.sm="100" fxFlex.xs="100" class="margin-right">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>{{ "storageName" | translate }}</mat-label>
            <input matInput required formControlName="name" autocomplete="off">
          </mat-form-field>
          <ng-container *ngIf="form.controls['name'].invalid">
            <mat-error *ngIf="form.controls['name'].errors.required">
              {{ "form.storage.required" | translate }}
            </mat-error>
          </ng-container>
        </div>
      </div>

    <!-- <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" class="cover">
        
      <div fxFlex="100" class="description_box">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>{{ "storageDescription" | translate }}</mat-label>
          <textarea matInput formControlName="description"></textarea>
        </mat-form-field>
      </div>

      
    </div> -->

    <!-- <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" class="cover">

      <div fxFlex="50" fxFlex.sm="100" fxFlex.xs="100" class="margin-right">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>{{ "storageSortOrder" | translate }}</mat-label>
          <input matInput formControlName="sortOrder" type="number" autocomplete="off">
        </mat-form-field>
      </div>

    </div> -->
    
    </form>

    <div fxLayout="flex" fxLayoutAlign="space-between center" class="bottom_update_btn">
      <h3></h3>
      <div>
        <button mat-button mat-raised-button mat-dialog-close (click)="cancel()" class="cancel_button">{{ "cancel" | translate }}</button>
        <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="!form.valid"
          data-test="storage-add__Submit">
          {{ 'form.storage.addStorage' | translate }}
        </button>
      </div>
    </div>

    
    
  </div>
<!-- </ng-template> -->